<top-banner variant="small"></top-banner>


<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <div class="form-row">
            <div class="col-md-12">
              <div class="temporary-information-message">
                <div>
                  <i class="fas fa-info-circle"></i>
                </div>
                <div>
                  <p>
                    Your training courses and inductions are managed on the
                    <a [routerLink]="['/', routeRole, 'training']">My Training</a>
                    page, and your competencies are managed on the
                    <a [routerLink]="['/', routeRole, 'manage-competencies']">My Competencies</a>
                    page.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header title="My Sites" icon="fas fa-list"></card-section-header>

          <!-- Table of results -->
          <div class="row">
            <div class="col-md-12">
              <!-- [lazy] must be set before [sortField]/[sortOrder]: paging and sorting are server-side, so
                   the table only ever holds the current page. Without lazy, it would also client-sort that
                   one page, briefly showing a wrong order over the server's result -->
              <p-table
                  [lazy]="true"
                  [value]="sites"
                  selectionMode="single"
                  [(selection)]="selectedSite"
                  [responsive]="true"
                  [autoLayout]="true"
                  (onSort)="customSort($event)"
                  [sortField]="defaultSortField"
                  [sortOrder]="defaultSortOrder"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th [pSortableColumn]="'site.name'">
                      Site Name
                      <p-sortIcon [field]="'site.name'"></p-sortIcon>
                    </th>
                    <th>Description</th>
                    <th [pSortableColumn]="'siteOwner'">
                      Owner
                      <p-sortIcon [field]="'siteOwner'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'site.siteType.name'">
                      Type
                      <p-sortIcon [field]="'site.siteType.name'"></p-sortIcon>
                    </th>
                    <th>Induction</th>
                    <th>Take Induction</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-site>
                  <tr [pSelectableRow]="site">
                    <td>
                      <span class="p-column-title">Site Name</span>
                      {{site.site.name}}
                      <div class="small-data">
                        <span>S{{site.site.id}}</span>
                      </div>
                    </td>

                    <td><span class="p-column-title">Description</span>{{site.site.description}}</td>
                    <td><span class="p-column-title">Owner</span>{{site.site.siteOwner.firstName}} {{site.site.siteOwner.lastName}}</td>
                    <td><span class="p-column-title">Type</span>{{site.site.siteType.name}}</td>
                    <td>
                      <span class="p-column-title">Induction</span>
                      <span *ngIf="site.site.siteInductionCourse && site.inductionForSite && site.inductionForSite.courseProgress === TrainingCourseStateType.Completed" class="badge badge-pill badge-success">Valid until: {{ site.inductionForSite.expiryDate | date : 'mediumDate' }}</span>
                      <span *ngIf="site.site.siteInductionCourse && site.inductionForSite && site.inductionForSite.courseProgress === TrainingCourseStateType.Expired" class="badge badge-pill badge-warning">Expired on: {{ site.inductionForSite.expiryDate | date : 'mediumDate' }}</span>
                      <span *ngIf="site.site.siteInductionCourse && !site.inductionForSite" class="badge badge-pill badge-danger">Not Passed</span>
                      <span *ngIf="!site.site.siteInductionCourse" class="badge badge-pill badge-default">Not Applicable</span>
                    </td>
                    <td>
                      <span class="p-column-title"></span>
                      <ng-container *ngIf="site.site.siteInductionCourse && !site.inductionForSite">
                        <button type="button" class="btn btn-round btn-primary" (click)="takeInduction(site.site.siteInductionCourse)">Take Induction</button>
                      </ng-container>
                      <ng-container *ngIf="site.site.siteInductionCourse && site.inductionForSite && site.inductionForSite.courseProgress === TrainingCourseStateType.Completed">
                        <button type="button" class="btn btn-primary btn-link" (click)="takeInduction(site.site.siteInductionCourse)">take again</button>
                      </ng-container>
                      <ng-container *ngIf="site.site.siteInductionCourse && site.inductionForSite && site.inductionForSite.courseProgress === TrainingCourseStateType.Expired">
                        <button type="button" class="btn btn-round btn-primary" (click)="takeInduction(site.site.siteInductionCourse)">Take Induction</button>
                      </ng-container>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="6">
                      No sites found
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <p-paginator #paginator [alwaysShow]="false" [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
